export default __webpack_public_path__ + "static/media/Q07_秋葉緩緩落下的紅褐色調.9f674958.mp4";